import { createFileRoute } from "@tanstack/react-router";
import { CATEGORY_PILLARS } from "@/data/category-pillars";
import { CategoryPillarPage, categoryPillarJsonLd } from "@/components/CategoryPillarPage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const pillar = CATEGORY_PILLARS.accounting;

export const Route = createFileRoute("/accounting/")({
  head: () => {
    const url = `${SEO_SITE}/accounting`;
    return {
      meta: [
        { title: ctaTitle(pillar.metaTitle, "/accounting", "th")},
        { name: "description", content: ctaDesc(pillar.metaDesc, "/accounting", "th")},
        { property: "og:title", content: ctaTitle(pillar.metaTitle, "/accounting", "th")},
        { property: "og:description", content: ctaDesc(pillar.metaDesc, "/accounting", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/accounting")],
      scripts: categoryPillarJsonLd(pillar, url),
    };
  },
  component: () => <CategoryPillarPage pillar={pillar} />,
});
